// INDEX APP SERVICES

import {
  // CORE
  WHDomEventService,
  WHLayoutConfigService,
  WHNgxLoggerService,
  WHMatSnackbarService,
  WHScrollbarService,
  WHThemeConfigService,
  DateTimeService,
  WHSafeTranslateService,

  // API
  WHDataService,
  WHTeamDataService,
  WHFeatureDataService,
  WHFeatureConfigDataService,
  WHI18nDataService,
  WHLoginDataService,
  WHMaterialDataService,
  WHSkillsDataService,
  WHMetadataDataService,
  WHSearchDataService,
  WHTenantDataService,
  WHUserDataService,

  // FLOW,
  WHBomNodeDataService,
  WHChecklistDefinitionDataService,
  WHChecklistInstanceDataService,
  WHCheckInstanceFileDataService,
  WHCustomerDataService,
  WHEquipmentDataService,
  WHEventLogDataService,
  WHFlexPropertyDefinitionDataService,
  WHToolDataService,
  WHWorkerDataService,
  WHWorkObjectDataService,
  WHWorkObjectTemplateDataService,
  WHWorkOrderDataService,
  WHWorkOrderFileDataService,
  WHWorkStepDataService,
} from '@workheld/workheld-shared-lib';
import { SERVICES_ASYNC } from './app-services-async/index.async.services';

export const SERVICES_CORE: any[] = [
  WHDomEventService,
  WHLayoutConfigService,
  WHSafeTranslateService,
  WHNgxLoggerService,
  WHMatSnackbarService,
  WHScrollbarService,
  WHThemeConfigService,
];

export const SERVICES_DATA: any[] = [
  WHMetadataDataService,
  DateTimeService,
  WHTenantDataService,
  WHUserDataService,
  WHDataService,
  WHChecklistDefinitionDataService,
  WHTeamDataService,
  WHI18nDataService,
  WHFeatureDataService,
  WHFeatureConfigDataService,
  WHLoginDataService,
  WHMaterialDataService,
  WHSkillsDataService,
  WHSearchDataService,
  // FLOW
  WHBomNodeDataService,
  WHChecklistInstanceDataService,
  WHCheckInstanceFileDataService,
  WHCustomerDataService,
  WHEquipmentDataService,
  WHEventLogDataService,
  WHFlexPropertyDefinitionDataService,
  WHWorkObjectDataService,
  WHToolDataService,
  WHWorkObjectTemplateDataService,
  WHWorkOrderDataService,
  WHWorkOrderFileDataService,
  WHWorkStepDataService,
  WHWorkerDataService,

  WHSafeTranslateService,
].concat(SERVICES_ASYNC);
